"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dateFns = require("date-fns");

var _useInterval = _interopRequireDefault(require("./useInterval"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useRelativeTime = function useRelativeTime(timestamp) {
  var calculateRelativeTime = function calculateRelativeTime() {
    return timestamp ? (0, _dateFns.formatDistanceStrict)(new Date(timestamp), Date.now(), {
      addSuffix: true
    }) : null;
  };

  var _useState = (0, _react.useState)(calculateRelativeTime()),
      _useState2 = _slicedToArray(_useState, 2),
      relativeTime = _useState2[0],
      setRelativeTime = _useState2[1];

  (0, _useInterval.default)(function () {
    setRelativeTime(calculateRelativeTime());
  }, 6000);
  var formattedDatetime = (0, _dateFns.format)(new Date(timestamp), 'MMM dd, yyyy h:mm a');
  return [relativeTime, formattedDatetime];
};

useRelativeTime.propTypes = {
  timestamp: _propTypes.default.string.isRequired
};
var _default = useRelativeTime;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/hooks/useRelativeTime.js
// module id = 815
// module chunks = 0 15 16 17 18